var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sanitizeBaseUrl } from "../../../utils";
import { createPayment, getPayment, getPaymentMethodClient, getPaymentMethods } from "../../evo-client/__generated__";
import { createClient, createConfig } from "../../evo-client/__generated__/client";
import { getPaymentDataFromEvoResponse, translatedPaymentMethodsEvo } from "./utils";
export class PgsApiEvo {
    constructor(baseUrl, tenantToken, recaptchaId) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    placeOrder(order) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { data } = yield createPayment({
                client: this.client,
                body: {
                    customer_uuid: order.customer.uuid,
                    order_id: Number(order.orderId),
                    tokenize: Boolean(order.tokenize_payment),
                },
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
            });
            return (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.payment_token) !== null && _b !== void 0 ? _b : "";
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getPaymentMethods({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
            });
            return { data: translatedPaymentMethodsEvo(data === null || data === void 0 ? void 0 : data.data) };
        });
    }
    getClient(code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { data } = yield getPaymentMethodClient({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
                path: {
                    code,
                },
            });
            return (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.client) !== null && _b !== void 0 ? _b : "";
        });
    }
    getOrderPaymentMethod(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getPayment({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
                path: {
                    uuid,
                },
            });
            return getPaymentDataFromEvoResponse(data);
        });
    }
}
//# sourceMappingURL=PgsApiEvo.js.map